export const ERROR_BOX_TONE_CLASS =
  "border-rose-300/80 bg-rose-100 text-rose-900 break-words whitespace-pre-wrap dark:border-rose-500/40 dark:bg-rose-500/10 dark:text-rose-100";

export const ERROR_DETAIL_TEXT_CLASS =
  "break-words whitespace-pre-wrap text-xs text-rose-800/90 dark:text-rose-100/80";
